import { writeSelectedRegionUrl } from './regionPreference';

export async function registerRegionRedirect(): Promise<void> {
    if (!('serviceWorker' in navigator) || !('indexedDB' in window)) {
        return;
    }

    try {
        const regionUrl = document.querySelector<HTMLMetaElement>('meta[name="trafiken-region-url"]')?.content;
        if (regionUrl) {
            await writeSelectedRegionUrl(regionUrl, window.location.origin);
        }

        await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
        await navigator.serviceWorker.ready;
        document.documentElement.dataset.regionRedirectReady = 'true';
    } catch (error) {
        console.warn('Region redirect service worker could not be initialized.', error);
    }
}
